const guaranteeJs = () => {
  const date = new Date
  let deltaTime = 0

  const trigger = (el, etype) => {
    const evt = new Event(etype, { bubbles: true })
    el.dispatchEvent(evt)
  }

  const checkIfLoaded = callback => {
    const form = document.querySelector('.ets_cf_form_data_contact')
		const newDate = new Date
    deltaTime = newDate - date

    if (form) return callback()
    if (deltaTime > 5000) return
    return setTimeout(() => checkIfLoaded(callback), 100)
  }

  const handleUploadFileChange = () => {
    const input = document.querySelector('.ets_cf_row_5 .ets_cf_form_control')
    const inputGroup = document.querySelector('.input_group')
    const updateAttribute = _event =>
      input.setAttribute('data-file', _event.target.value)
    const preventClick = _event => _event.preventDefault()

    input.addEventListener('change', updateAttribute)
    inputGroup.addEventListener('keydown', preventClick)

    window.onunload = function () {
      input.removeEventListener('change', updateAttribute)
      inputGroup.removeEventListener('keydown', preventClick)
    }
  }

  const sendFormListeners = () => {
    const sendingButton = document.querySelector('.ets_cf_btn_submit')
    const sendButtonWithNL = document.getElementById(
      'guarantee_submit_and_subscribe'
    )
    const sendButton = document.getElementById('guarantee_submit')
		const guaranteeInputs = [...document.querySelectorAll('.ets_cf_form_control')]
		const guaranteeLastname = guaranteeInputs.find(input => input.name === 'lastName')
		const guaranteeFirstname = guaranteeInputs.find(input => input.name === 'firstName')
		const guaranteeEmail = guaranteeInputs.find(input => input.name === 'email')
		const nlFormLastname = document.querySelector('.guarantee-nl-lastname')
		const nlFormFirstname = document.querySelector('.guarantee-nl-firstname')
		const nlFormEmail = document.querySelector('.guarantee-nl-email')

		const handleChange = (_event, output) => {
			output.value = _event.target.value
		}

		const handleChangeLastname = _event => handleChange(_event, nlFormLastname)
		const handleChangeFirstname= _event => handleChange(_event, nlFormFirstname)
		const handleChangeEmail = _event => handleChange(_event, nlFormEmail)

		guaranteeLastname.addEventListener('change', handleChangeLastname)
		guaranteeFirstname.addEventListener('change', handleChangeFirstname)
		guaranteeEmail.addEventListener('change', handleChangeEmail)

    const sendForm = () => sendingButton.click()
		const sendNLForm = () => {
			const NLForm = document.querySelector('.guarantee-nl-form')
			const radios = [...document.querySelectorAll('.ets_cf_radio_check')].map(el => getComputedStyle(el, '::after').content)
			const radioCheck = radios.filter(radio => radio === '""')

			const guaranteePurchaseDate = guaranteeInputs.find(input => input.name === 'purchaseDate')
			const guaranteePurchaseFile = guaranteeInputs.find(input => input.name === 'purchaseFile')

			if(!radioCheck.length || !guaranteeLastname.value || !guaranteeFirstname.value || !guaranteeEmail.value || !guaranteePurchaseDate.value || !guaranteePurchaseFile.value ){
				return sendForm()
			}
			sendForm()
			setTimeout(() => NLForm.submit(), 3000)
		}

    sendButtonWithNL.addEventListener('click', sendNLForm)
    sendButton.addEventListener('click', sendForm)

    window.onunload = function () {
      sendButtonWithNL.removeEventListener('click', sendForm)
      sendButton.removeEventListener('click', sendForm)
			guaranteeLastname.removeEventListener('change', handleChangeLastname)
			guaranteeFirstname.removeEventListener('change', handleChangeFirstname)
			guaranteeEmail.removeEventListener('change', handleChangeEmail)
    }
  }

	const createDatePicker = () => {
      const el = document.querySelector('.ets_cf_input_date')
      const datePicker = new Datepicker(el, {
        autohide: true,
        language: 'fr',
        prevArrow: "<",
        nextArrow: ">",
        weekStart: 1,
				format: 'yyyy-mm-dd'
      })
    }

		const hideClaim = () => {
			const thanksMessage = document.querySelector('.ets_cf_thank_msg.ets_cf_remove_form')
			const claim = document.querySelector('.guarantee_claims')
			const buttons = document.querySelector('.contact__button')

			if(thanksMessage){
				claim.style.display = 'none'
				buttons.style.display = 'none'
			}
		}

		const isLoaded = () => {
			createDatePicker()
			sendFormListeners()
			handleUploadFileChange()
			onDomChange(function() {
				setTimeout(hideClaim)
			})
		}

		checkIfLoaded(isLoaded)
}

guaranteeJs()
